import axios from "axios";
import Vue from "vue";

axios.defaults.validateStatus = () => {
  return true;
};

const API_HOSTNAME = process.env.VUE_APP_API_HOSTNAME;
const API_PORT = process.env.VUE_APP_API_PORT;

console.log(
  `ABout to create Axios with host ${API_HOSTNAME} and port ${API_PORT}`
);

const axiosObj = axios.create({
  baseURL: `${API_HOSTNAME}:${API_PORT}`,
  withCredentials: true // Can be set to true if CORS is enabled.
});

axiosObj.interceptors.response.use(
  function(response) {
    console.log("AHHHH AXIOS RESPONSE");
    console.log(response);
    if (response.status == 401) {
      console.log("pushing!");
      //return router.push("/login");
      return (window.location.href = "/login");
    }

    if (response.status == 404) {
      return (window.location.href = "/404");
    }

    if (response && !response.data.success) {
      let msg = "Oh no - an error has occurred. Please try again later.";
      switch (typeof response.data.msg) {
        case "string":
          msg = response.data.msg;
          break;
        case "array":
          msg = response.data.msg.join("/n");
          break;
      }

      Vue.$gtag.event("error", {
        event_category: "user_error",
        event_label: msg
      });

      Vue.toasted.show(msg, {
        type: "error",
        theme: "toasted-primary",
        position: "top-center",
        duration: 5000
      });

      // Don't return anything here.
    }
    return response;
  },
  function(error) {
    console.log("ERROR OCCURRED!");
    console.log(error);
    // handle error
    if (error.response) {
      Vue.$gtag.event("error", {
        event_category: "api_error"
      });

      return Vue.toasted.show("Sorry, something went wrong.", {
        type: "error",
        theme: "toasted-primary",
        position: "top-center",
        duration: 5000
      });
    }
  }
);

export default axiosObj;
